import { DataTable } from "components/base/DataTable"
import Section from "components/base/Section"
import { Title } from "components/base/Title"
import { useEffect, useState } from "react";
import {Facture, genererPdf, getFactures} from "services/apiFactures";
import { handleApiError } from "utils/errorHandlers";
import { ApiLoading } from "components/ApiLoading";
import { formatDate } from "utils/utils";
import { generateFacture } from "utils/generateFacture";

export const FacturePage: React.FC<{isAdmin?: boolean}> = ({isAdmin = false}) => {
  const [factures, setFactures] = useState<Facture[]>([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState<Record<string, string[]>>({});

  useEffect(() => {
    const fetchFactures = async () => {
      try {
        const data = await getFactures();
        setFactures(data);
      } catch (error: any) {
        setErrors(handleApiError(error));
      } finally {
        setLoading(false);
      }
    };
    fetchFactures();
  }, []);
 
  if (errors && errors.general) {
    return <ApiLoading type="error">{errors.general[0]}</ApiLoading>;
  }

  if (loading) {
    return <ApiLoading type="loading">Chargement des factures...</ApiLoading>;
  }

  if (factures.length === 0) {
    return <ApiLoading type="no-data">Aucune facture trouvée</ApiLoading>;
  }

	const handleDownload = async (facture: Facture) => {
		const html = generateFacture(facture);
		const response = await genererPdf(html);
		const url = window.URL.createObjectURL(new Blob([response.data]));
		const a = document.createElement("a");
		a.href = url;
		a.download = `facture-${facture.numero_facture}.pdf`;
		document.body.appendChild(a);
		a.click();
		a.remove();
		window.URL.revokeObjectURL(url);
	};

  return (
    <Section fullwidth>
      <Title type="h2" className="mb-4">Listes des factures</Title>
      <DataTable
        columns={[
          {key: 'numero_facture', label: 'N° Facture',},
	        {key: 'client', label: 'Client', hidden: !isAdmin},
          {key: 'montant_total_formate', label: 'Montant',},
          {key: 'nb_produits', label: 'Nb de produits',},
          {key: 'created_at', label: 'Date de création', render: (value: string) => formatDate(value)},
        ]}
        actions={[
          {label: 'Télécharger', buttonVariant: "primary", onClick: (row) => handleDownload(row)},
        ]}
        actionWidth='w-32'
        data={factures}
      />
    </Section>
  )
}